import PropTypes from 'prop-types';
import React from 'react';

import { IMAGE_BG_COLOR } from 'constants/images';
import Theme from 'styles/theme';

import AddButton from './AddButton';
import Details from './Details';
import Image from './Image';
import Price from './Price';

const Upsell = class extends React.PureComponent {
  static propTypes = {
    addToCart: PropTypes.func.isRequired,
    imageSrc: PropTypes.string.isRequired,
    imageAlt: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    colorName: PropTypes.string.isRequired,
    localizedSize: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    price: PropTypes.number.isRequired,
    linkUrl: PropTypes.string.isRequired,
  };

  static defaultProps = {
    children: null,
  };

  render() {
    const {
      addToCart,
      imageSrc,
      imageAlt,
      headline,
      colorName,
      localizedSize,
      children,
      price,
      linkUrl,
    } = this.props;

    return (
      <div className="Upsell Upsell--shoe-accessory">
        <a href={linkUrl} className="Upsell__image">
          <Image src={imageSrc} alt={imageAlt} />
        </a>
        <div className="Upsell__content">
          <div className="Upsell__content-top">
            <Details headline={headline} colorName={colorName} localizedSize={localizedSize} />
            <AddButton onClick={addToCart} />
          </div>
          <div className="Upsell__content-bottom">
            <div className="Upsell__children">{children}</div>
            <Price value={price} />
          </div>
        </div>
        <style jsx>
          {`
            .Upsell {
              display: flex;
              width: 100%;
              background-color: ${IMAGE_BG_COLOR};
              padding: ${Theme.get('spacing') * 4}px ${Theme.get('spacing') * 3}px;
            }

            .Upsell__image {
              margin-right: ${Theme.get('spacing') * 2}px;
              flex-shrink: 0;
            }

            .Upsell__content {
              display: flex;
              flex-direction: column;
              width: 100%;
              min-width: 0;
            }

            .Upsell__content-top {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
            }

            .Upsell__content-bottom {
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
          `}
        </style>

        <style jsx global>
          {`
            .Upsell__image-container .Image {
              width: 45px;
            }
          `}
        </style>
      </div>
    );
  }
};

export default Upsell;
